import React, {useEffect, useMemo, useState} from 'react'
import CarsList from "./carslist";
import CarsTopTools from "../elements/carsTopTools";
import CarModalBox from "../elements/cardmodal";
import {Carcontext} from "../context/carcontext";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {
    SET_ORDER_LINK,
    SET_RENT_END_DATE, SET_RENT_END_TIME,
    SET_RENT_START_DATE, SET_RENT_START_TIME,
    TOGGLE_FALSE_LOGGED_CLIENT,
    TOGGLE_TRUE_LOGGED_CLIENT
} from "../redux/types";
import i18n from "i18next";
import {fetchCars, showAlert} from "../redux/actions";

const logout = <svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="sign-out-alt" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor"d="M160 217.1c0-8.8 7.2-16 16-16h144v-93.9c0-7.1 8.6-10.7 13.6-5.7l141.6 143.1c6.3 6.3 6.3 16.4 0 22.7L333.6 410.4c-5 5-13.6 1.5-13.6-5.7v-93.9H176c-8.8 0-16-7.2-16-16v-77.7m-32 0v77.7c0 26.5 21.5 48 48 48h112v61.9c0 35.5 43 53.5 68.2 28.3l141.7-143c18.8-18.8 18.8-49.2 0-68L356.2 78.9c-25.1-25.1-68.2-7.3-68.2 28.3v61.9H176c-26.5 0-48 21.6-48 48zM0 112v288c0 26.5 21.5 48 48 48h132c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12H48c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16h132c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12H48C21.5 64 0 85.5 0 112z"></path></svg>

const CarsPage = () => {

    const {t} = useTranslation()
    const dispatch = useDispatch()
    const loggedClient = useSelector(state => state.clients.isLoggedIn)
    const orderLink = useSelector(state => state.orders.orderLink)
    const theme = useSelector(state => state.app.theme)
    const paginationData = useSelector(state => state.cars.paginationData)

    const [modal, setModal] = useState({})
    const [carContext, setCarContext] = useState('')
    const [loggedInUserData, setLoggedInUserData] = useState({})

    useEffect(() => {
        const modal = document.querySelector('.modal-wrapper')
        try {
            const userData = JSON.parse(localStorage.getItem(`newCreatedUserData`))
            setLoggedInUserData(userData)
        } catch (e) {}
        setModal(modal)

        // setting min dates for car selection :)

        setTimeout(() => {
            if (loggedClient) {
                setMinDates()
            }
        }, 1000)

    }, [])

    function setMinDates() {
        const today = new Date()
        let dd = today.getDate();
        let mm = today.getMonth() + 1; //January is 0!
        let yyyy = today.getFullYear();

        if (dd < 10) {
            dd = '0' + dd;
        }

        if (mm < 10) {
            mm = '0' + mm;
        }

        // let currentDay = `${yyyy}-${mm}-${dd}`
        let nextDay = `${yyyy}-${mm}-${dd+1}`

        const minEndDate = document.querySelector('#end')

        minEndDate && minEndDate.setAttribute('min', nextDay)
    }

    const OpenCarModal = (car) => {
          modal.style.cssText = "opacity: 1; visibility: visible;";
          setCarContext(car);
    }

    const CloseModal = () => {
        modal.style.cssText = "opacity: 0; visibility: hidden;";
    }

    const carModal = useMemo(() => {
        return <CarModalBox cars={carContext} theme={theme}/>
    }, [carContext, theme])

    const logOutFromProfile = () => {
        dispatch({type: TOGGLE_FALSE_LOGGED_CLIENT})
        dispatch(showAlert('You have logged out!', 'warning'))
        localStorage.removeItem('newCreatedUserData')
    }

    const setRentDates = (e) => {
        if (e.target.name === 'start') {
            dispatch({type: SET_RENT_START_DATE, payload: e.target.value})
        } else if (e.target.name === 'end') {
            dispatch({type: SET_RENT_END_DATE, payload: e.target.value})
        } else if (e.target.name === 'timeStart') {
            dispatch({type: SET_RENT_START_TIME, payload: e.target.value})
        } else if (e.target.name === 'timeEnd') {
            dispatch({type: SET_RENT_END_TIME, payload: e.target.value})
        }
    }

    const nextPage = (nextPage) => {
        dispatch(fetchCars(null, nextPage))
    }

    if (orderLink) {
        let linkForDoc = document.createElement('a')
        linkForDoc.setAttribute('href', `https://rezilizer.ru/${orderLink}`)
        linkForDoc.setAttribute('download', "download")
        linkForDoc.click()
        dispatch({type: SET_ORDER_LINK, payload: null})
        dispatch({type: TOGGLE_TRUE_LOGGED_CLIENT})
    }

    return (
        <Carcontext.Provider value={{
            OpenCarModal, CloseModal, theme
        }}>
            <div className="content">
                <div className="wrapper">
                    <div className="modal-wrapper">{carModal}</div>
                    <CarsTopTools />
                    <h2 className={`carSelectionFor ${theme}`}>
                        {
                            (() => {
                                if (loggedClient) {
                                    if (loggedInUserData.newUserStatus === 'vacant') {
                                        if (i18n.language === 'uz') {
                                            return (
                                                <>
                                                    {t('carSelection')} : {loggedInUserData.newUserSurname} {loggedInUserData.newUserName}ga <br/>
                                                    <input type="date" id="start" name="start" onChange={setRentDates}/> {t('carSelectionFrom')} <input type="date" id="end" name="end" onChange={setRentDates}/> {t('carSelectionTo')}<br /><br/>
                                                    {t('hours')} : <input type="time" name="timeStart" onChange={setRentDates}/> - <input type="time" name="timeEnd" onChange={setRentDates}/><br/><br/>
                                                    {t('logOutFromProfile')} : <div className="userLogOut" onClick={logOutFromProfile}><p>{t('logOut')}</p>{logout}</div>
                                                </>
                                            )
                                        } else {
                                            return (
                                                <>
                                                    {t('carSelection')} {loggedInUserData.newUserSurname} {loggedInUserData.newUserName} <br/>
                                                    {t('carSelectionFrom')} <input type="date" id="start" name="start" onChange={setRentDates}/> {t('carSelectionTo')} <input type="date" id="end" name="end" onChange={setRentDates}/><br/><br/>
                                                    {t('hours')} : <input type="time" name="timeStart" onChange={setRentDates}/> - <input type="time" name="timeEnd" onChange={setRentDates}/><br/><br/>
                                                    {t('logOutFromProfile')} : <div className="userLogOut" onClick={logOutFromProfile}><p>{t('logOut')}</p>{logout}</div>
                                                </>
                                            )
                                        }
                                    } else if (loggedInUserData.newUserStatus === 'occupied') {
                                        if (i18n.language === 'uz') {
                                            return (
                                                <>
                                                    {t('carSelection')} : {loggedInUserData.newUserSurname} {loggedInUserData.newUserName}ga <br/>
                                                    <input type="date" id="start" name="start" onChange={setRentDates}/> {t('carSelectionFrom')} <input type="date" id="end" name="end" onChange={setRentDates}/> {t('carSelectionTo')}<br /><br/>
                                                    {t('hours')} : <input type="time" name="timeStart" onChange={setRentDates}/> - <input type="time" name="timeEnd" onChange={setRentDates}/><br/><br/>
                                                    <strong>{t('thisUserIsCurrentlyRentingACar')}</strong><br />
                                                    {t('checkInOrders')} <br/>
                                                    {t('logOutFromProfile')} : <div className="userLogOut" onClick={logOutFromProfile}><p>{t('logOut')}</p>{logout}</div>
                                                </>
                                            )
                                        } else {
                                            return (
                                                <>
                                                    {t('carSelection')} {loggedInUserData.newUserSurname} {loggedInUserData.newUserName} <br/>
                                                    {t('carSelectionFrom')} <input type="date" id="start" name="start" onChange={setRentDates}/> {t('carSelectionTo')} <input type="date" id="end" name="end" onChange={setRentDates}/><br/><br/>
                                                    {t('hours')} : <input type="time" name="timeStart" onChange={setRentDates}/> - <input type="time" name="timeEnd" onChange={setRentDates}/><br/><br/>
                                                    <strong>{t('thisUserIsCurrentlyRentingACar')}</strong><br />
                                                    {t('checkInOrders')} <br/>
                                                    {t('logOutFromProfile')} : <div className="userLogOut" onClick={logOutFromProfile}><p>{t('logOut')}</p>{logout}</div>
                                                </>
                                            )
                                        }
                                    }
                                }
                            }) ()
                        }
                    </h2>
                    <CarsList />
                    <div className={`pagination-items ${theme}`}>
                        {
                            !!paginationData.previous ? <div className="previos-page" onClick={() => nextPage(paginationData.previous)}>{t('previous')}</div> : ''
                        }
                        {
                            !!paginationData.next ? <div className="next-page" onClick={() => nextPage(paginationData.next)}>{t('next')}</div> : ''
                        }
                    </div>
                </div>
            </div>
        </Carcontext.Provider>
    )
}

export default CarsPage
